
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChangeAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.495 5.193a5.22 5.22 0 0 1 5.22 5.22 5.212 5.212 0 0 1-2.145 4.217 8.278 8.278 0 0 1 3.7 2.923.8.8 0 0 1-1.309.92 6.684 6.684 0 0 0-10.933 0 .8.8 0 0 1-1.308-.92 8.276 8.276 0 0 1 3.698-2.923 5.22 5.22 0 0 1 3.077-9.437Zm0 1.6a3.62 3.62 0 1 0 .001 7.241 3.62 3.62 0 0 0 0-7.241Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.09 5.276a.8.8 0 1 0 .434 1.54l-.217-.77-.217-.77Zm4.855 2.177-.609.52.609-.52Zm.98 1.999-.782.164.783-.164Zm-.317 2.802.727.335-.727-.335Zm-4.081 1.813a.8.8 0 1 0 0 1.6v-1.6Zm-.001 0a.8.8 0 0 0 .001 1.6v-.8l-.001-.8Zm5.569 4.492a.8.8 0 1 0 1.31-.92l-.655.46-.655.46ZM14.307 6.046l.217.77a3.695 3.695 0 0 1 3.812 1.157l.609-.52.608-.519a5.295 5.295 0 0 0-5.463-1.658l.217.77Zm4.638 1.407-.609.52a3.69 3.69 0 0 1 .807 1.643l.783-.164.783-.164a5.289 5.289 0 0 0-1.156-2.354l-.608.52Zm.98 1.999-.782.164c.16.761.077 1.569-.261 2.303l.726.335.727.335a5.292 5.292 0 0 0 .374-3.3l-.783.163Zm-.317 2.802-.726-.335a3.695 3.695 0 0 1-3.355 2.148v1.6a5.295 5.295 0 0 0 4.808-3.078l-.727-.335Zm-4.081 2.613v.8a6.797 6.797 0 0 1 5.568 2.892l.655-.46.654-.46a8.397 8.397 0 0 0-6.878-3.572v.8Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.49519 5.19318C11.3779 5.19343 13.7157 7.53015 13.7159 10.4129C13.7159 12.1457 12.8701 13.6801 11.5704 14.6297C13.0404 15.2181 14.3336 16.2213 15.2696 17.5526C15.5233 17.9139 15.4365 18.4128 15.0753 18.6668C14.714 18.9208 14.2152 18.8336 13.961 18.4725C12.7097 16.6929 10.6697 15.6336 8.49422 15.6336C6.31888 15.6338 4.27953 16.6929 3.0284 18.4725C2.77433 18.8338 2.27556 18.9208 1.91414 18.6668C1.55276 18.4127 1.46574 17.914 1.7198 17.5526C2.6557 16.2214 3.94827 15.2181 5.41804 14.6297C4.11913 13.68 3.27547 12.1452 3.27547 10.4129C3.27566 7.53011 5.6124 5.19336 8.49519 5.19318ZM8.49519 6.79279C6.49605 6.79297 4.87527 8.41376 4.87507 10.4129C4.87507 12.4122 6.49593 14.0328 8.49519 14.033C10.4944 14.0328 12.1153 12.4122 12.1153 10.4129C12.1151 8.41381 10.4943 6.79304 8.49519 6.79279Z\" fill=\"#000000\"/>\r\n<path d=\"M14.0902 5.27568C13.6649 5.3955 13.4173 5.83738 13.5371 6.26265C13.6569 6.68792 14.0988 6.93554 14.5241 6.81572L14.3071 6.0457L14.0902 5.27568ZM18.9446 7.45344L18.3362 7.97292L18.9446 7.45344ZM19.9259 9.45197L19.1429 9.61567L19.9259 9.45197ZM19.6082 12.2542L20.3347 12.5891V12.5891L19.6082 12.2542ZM15.5266 14.0673C15.0847 14.0673 14.7266 14.4255 14.7267 14.8674C14.7267 15.3092 15.0849 15.6673 15.5267 15.6673L15.5267 14.8673L15.5266 14.0673ZM15.526 14.0674C15.0841 14.0678 14.7262 14.4262 14.7266 14.868C14.7269 15.3098 15.0853 15.6678 15.5271 15.6674L15.5266 14.8674L15.526 14.0674ZM21.095 18.5589C21.3488 18.9205 21.8478 19.0079 22.2094 18.754C22.571 18.5001 22.6583 18.0012 22.4045 17.6396L21.7497 18.0992L21.095 18.5589ZM14.3071 6.0457L14.5241 6.81572C15.9117 6.42475 17.4 6.87654 18.3362 7.97292L18.9446 7.45344L19.5529 6.93396C18.2115 5.36284 16.0787 4.71542 14.0902 5.27568L14.3071 6.0457ZM18.9446 7.45344L18.3362 7.97292C18.747 8.45411 19.0185 9.0205 19.1429 9.61567L19.9259 9.45197L20.709 9.28827C20.5308 8.43554 20.1415 7.62327 19.5529 6.93396L18.9446 7.45344ZM19.9259 9.45197L19.1429 9.61567C19.3021 10.3771 19.2204 11.1845 18.8817 11.9192L19.6082 12.2542L20.3347 12.5891C20.8202 11.5362 20.9369 10.3786 20.709 9.28827L19.9259 9.45197ZM19.6082 12.2542L18.8817 11.9192C18.2781 13.2285 16.9682 14.0671 15.5266 14.0673L15.5267 14.8673L15.5267 15.6673C17.5927 15.667 19.4698 14.4652 20.3347 12.5891L19.6082 12.2542ZM15.5266 14.8674L15.5271 15.6674C17.7435 15.6658 19.8215 16.745 21.095 18.5589L21.7497 18.0992L22.4045 17.6396C20.8312 15.3986 18.2641 14.0655 15.526 14.0674L15.5266 14.8674Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/change-account.2de4268cfb472c2ff41db00852859436.svg"),
        {
          React: SvgChangeAccount,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      